import { fetchApi } from "../utils/fetchApi";

export function fetchUserrequest({ filter = {}, options = {} }) {
  return fetchApi({ url: 'tracking/action'}, null , options );
}

